import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  IconButton,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Label from "../../../components/Label/Label";

const ReportNameDialog = ({
  open,
  onClose,
  onSubmit,
  isTemplate = false,
  mode,
}) => {
  const MAX_NAME_LENGTH = 30;
  const MAX_DESC_LENGTH = 200;

  const [inputs, setInputs] = useState({ name: "", description: "" });
  const [nameError, setNameError] = useState("");
  const [descError, setDescError] = useState("");

  useEffect(() => {
    if (mode === "edit") {
      setInputs({
        name: "",
        description: "",
      });
    }
  }, [mode]);

  const handleNameChange = (e) => {
    const value = e.target.value.trimStart();
    if (value.length > MAX_NAME_LENGTH) {
      setNameError(`Maximum ${MAX_NAME_LENGTH} characters allowed`);
      return;
    }
    setNameError("");
    setInputs((prev) => ({ ...prev, name: value }));
  };

  const handleDescriptionChange = (e) => {
    const value = e.target.value.trimStart();
    if (value.length > MAX_DESC_LENGTH) {
      setDescError(`Maximum ${MAX_DESC_LENGTH} characters allowed`);
      return;
    }
    setDescError("");
    setInputs((prev) => ({ ...prev, description: value }));
  };

  const handleSubmit = () => {
    onSubmit(inputs, isTemplate);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ m: 0, p: 2 }}>
        <Label text="Enter Report Details" />
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <TextField
          label="Report Name"
          fullWidth
          margin="normal"
          value={inputs.name}
          onChange={handleNameChange}
          error={!!nameError}
          helperText={nameError || `${inputs.name.length}/${MAX_NAME_LENGTH}`}
        />

        <TextField
          label="Description"
          fullWidth
          margin="normal"
          multiline
          rows={3}
          value={inputs.description}
          onChange={handleDescriptionChange}
          error={!!descError}
          helperText={
            descError || `${inputs.description.length}/${MAX_DESC_LENGTH}`
          }
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          <Label text="Cancel" color="inherit" />
        </Button>
        <Button
          onClick={handleSubmit}
          color="primary"
          variant="contained"
          disabled={!inputs.name.trim() || nameError || descError}
        >
          <Label text="Submit" color="inherit" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReportNameDialog;
